/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'doctrine/tech_2': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M28 19.354L31.354 16 28 12.646V4h-8.646L16 .646 12.646 4H4v8.646L.646 16 4 19.354V28h8.646L16 31.354 19.354 28H28v-8.646zM30.646 16L28 18.646v-5.293L30.646 16zM16 1.354L18.646 4h-5.293L16 1.354zM1.354 16L4 13.354v5.292L1.354 16zM16 30.646L13.354 28h5.292L16 30.646zM26 26H6V6h20v20z"/><path pid="1" d="M14 14h4v4h-4z"/><path pid="2" d="M24 15v-1h-3v-3h-3V8h-1v3h-2V8h-1v3h-3v3H8v1h3v2H8v1h3v3h3v3h1v-3h2v3h1v-3h3v-3h3v-1h-3v-2h3zm-5 4h-6v-6h6v6z"/>'
  }
})
